import { DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';

export const INDETERMINATE_MAX = Infinity;

export class GalaxyPaginatorText extends MatPaginatorIntl {
  private ofLabel = 'GALAXY.PAGINATION.OF';
  private indeterminateLabel = 'GALAXY.PAGINATION.INDETERMINATE_AMOUNT';

  constructor(
    private readonly translate: TranslateService,
    private readonly destroyRef?: DestroyRef,
  ) {
    super();

    this.streamLabel('GALAXY.PAGINATION.PAGE_SIZE', (v) => (this.itemsPerPageLabel = v));
    this.streamLabel('GALAXY.PAGINATION.NEXT_PAGE', (v) => (this.nextPageLabel = v));
    this.streamLabel('GALAXY.PAGINATION.PREVIOUS_PAGE', (v) => (this.previousPageLabel = v));
    this.streamLabel('GALAXY.PAGINATION.OF', (v) => (this.ofLabel = v));
    this.streamLabel('GALAXY.PAGINATION.INDETERMINATE_AMOUNT', (v) => (this.indeterminateLabel = v));
  }

  getRangeLabel = (page: number, pageSize: number, length: number): string => {
    if (length === 0 || pageSize === 0) {
      return `0 ${this.ofLabel} ${length}`;
    }
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
    return `${startIndex + 1} - ${endIndex} ${this.ofLabel} ${
      length === INDETERMINATE_MAX ? this.indeterminateLabel : length
    }`;
  };

  private streamLabel(key: string, setter: (value: string) => void): void {
    const stream$ = this.translate.stream(key);
    (this.destroyRef ? stream$.pipe(takeUntilDestroyed(this.destroyRef)) : stream$).subscribe((value: string) => {
      setter(value);
      this.changes.next();
    });
  }
}
